import { cn } from '@/ui/kit'

export { cn }

/** `size` is accepted as a token or a number of pixels. */
export const SIZE_PX = { small: 8, middle: 16, large: 24 }

export const resolveSize = (size, fallback = 'middle') => {
  if (typeof size === 'number') return size
  return SIZE_PX[size] ?? SIZE_PX[fallback]
}

/** antd `Row`/`Col` use a 24-column grid. */
export const GRID_COLUMNS = 24

export const asPercentWidth = (span) =>
  span == null ? undefined : `${(Number(span) / GRID_COLUMNS) * 100}%`

/** Splits antd's `gutter` prop (number | [h, v] | responsive object) into pixels. */
export const resolveGutter = (gutter) => {
  if (gutter == null) return [0, 0]
  if (Array.isArray(gutter)) {
    const [h, v] = gutter
    return [typeof h === 'number' ? h : 0, typeof v === 'number' ? v : 0]
  }
  if (typeof gutter === 'number') return [gutter, 0]
  return [0, 0]
}

/** Renders antd's `ReactNode | () => ReactNode` shape. */
export const renderNode = (node, ...args) =>
  typeof node === 'function' ? node(...args) : node

/** Resolves a dotted path, matching antd `Descriptions`/`Table` dataIndex semantics. */
export const getPath = (source, path) => {
  if (source == null || path == null) return undefined
  const segments = Array.isArray(path) ? path : String(path).split('.')
  return segments.reduce((acc, key) => (acc == null ? undefined : acc[key]), source)
}

let idCounter = 0
export const nextId = (prefix = 'kit') => {
  idCounter += 1
  return `${prefix}-${idCounter}`
}
